import { useState } from "react";
import { Button, Card, CardBody } from "reactstrap";
import { Loader, ShieldCheck } from "lucide-react";

export const CaseCreationForm = ({ logoPath, biSubmitUrl, paSubmitUrl }) => {
  const [processing, setProcessing] = useState(null);

  const handleButtonState = (url) => {
    setProcessing(url);
    window.location.href = url;
  };

  return (
    <>
      <div className="d-flex flex-column justify-elements-center align-items-center gap-2">
        <img src={logoPath} style={{ height: 50, width: 200 }} />
        <p className="display-6 fw-light">Submit to careviso</p>
      </div>

      <hr className="text-muted w-100" />

      <div className="d-flex flex-row gap-4 align-items-center justify-content-center mt-4">
        <Card className="bg-white pt-0">
          <CardBody className="pt-0">
            <div className="w-100 bg-secondary mb-2" style={{ height: 2 }}></div>

            <p className="text-uppercase fw-bolder text-secondary">
              <Loader size={16} className="me-2" />
              Benefits Investigation
            </p>

            <h3 className="display-6 fw-medium">seeQer</h3>

            <blockquote className="blockquote">
              <p className="text-muted">
                Confirm patient coverage, out-of-pocket estimate,
                <br /> and network status before scheduling.
              </p>
            </blockquote>

            <ul className="ps-3">
              <li className="text-muted">Pre-treatment benefits investigation</li>
              <li className="text-muted">Deductible, co-pay & out-of-pocket estimate</li>
              <li className="text-muted">Coverage confirmation & in-network check</li>
              <li className="text-muted">Prior auth requirement & approval likelihood</li>
            </ul>

            <hr className="text-muted" />

            <Button
              className="btn btn-secondary bg-transparent fw-bold text-secondary"
              onClick={() => handleButtonState(biSubmitUrl)}
              disabled={processing !== null}
            >
              {processing === biSubmitUrl ? "Processing..." : "Start seeQer"}
            </Button>
          </CardBody>
        </Card>

        <Card className="bg-white pt-0">
          <CardBody className="pt-0">
            <div className="w-100 bg-success mb-2" style={{ height: 2 }}></div>
            <p className="text-uppercase fw-bolder text-success">
              <ShieldCheck size={16} className="me-2" />
              Prior Authorization
            </p>

            <h3 className="display-6 fw-medium">Prior Auth</h3>

            <blockquote className="blockquote">
              <p className="text-muted">
                Open a PA case and submit clinical documentation
                <br />
                to the payer on the patient's behalf.
              </p>
            </blockquote>

            <ul className="mb-4 pb-2 ps-3">
              <li className="text-muted">PA requirement visibility</li>
              <li className="text-muted">Electronic submission & tracking</li>
              <li className="text-muted">Approval likelihood</li>
            </ul>

            <hr className="text-muted" />

            <Button
              className="btn btn-secondary bg-transparent fw-bold text-secondary"
              onClick={() => handleButtonState(paSubmitUrl)}
              disabled={processing !== null}
            >
              {processing === paSubmitUrl ? "Processing..." : "Start Prior Authorization"}
            </Button>
          </CardBody>
        </Card>
      </div>
    </>
  );
};
